
declare var dataLayer: any;

export interface iUtilsTM { createCookie: Function, readCookie: Function }
export class TagManager {

	private utils: iUtilsTM;

	constructor(utils: iUtilsTM) {
		this.utils = utils;
	}

	eventViewItemList(cars_results: any) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

		let items: any = [];
		cars_results.forEach((element: any, index: any) => {
			items.push({
				item_id: element.id,
				item_name: element.nombre,
				price: element.precio,
				item_brand: element.marca,
				item_category: element.gama.nomb,
				item_category2: element.rentadora,
				quantity: 1,
				index: index,
				currency: 'COP'
			})
		});
		dataLayer.push({
			event: "view_item_list",
			ecommerce: {
				items: items
			}
		});
	}

	eventItem(element: any, event: any) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: event,// "select_item",
			ecommerce: {
				items: [{
					item_id: element.id,
					item_name: element.nombre,
					price: element.precio,
					item_brand: element.marca,
					item_category: element.gama,
					item_category2: element.rentadora,
					quantity: 1,
					index: element.index,
					currency: 'COP'
				}]
			}
		});
	}

	eventItemOnly(event: any) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: event,// "select_item",
		});
	}

	onPurchase(element: any) {

		var purchase_cookie = this.utils.readCookie('purchase');

		if (purchase_cookie == element.transaction_id) {
			return;
		}

		this.utils.createCookie('purchase', element.transaction_id, 5, Domain);

		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
		dataLayer.push({
			event: "purchase",
			ecommerce: {
				currency: "COP",
				transaction_id: element.transaction_id,
				items: [{
					item_id: element.id,
					item_name: element.modelo,
					price: element.precio,
					item_brand: element.marca,
					item_category: element.gama,
					item_category2: element.rentadora,
					quantity: 1,
					index: 1,
					currency: 'COP'
				}],
				value: element.precio
			}
		});
	}
}